<template>
    <div class="icon">
        <img v-bind:src="iconSource(chapter)"  alt="..." class="icon" :class="chapter.state === 'locked' ? 'locked' : ''">
    </div>
</template>

<script>
    export default {
        props: {
            chapter: {
                type: Object
            }
        },
        methods:{
            iconSource(chapter){
                let iconName = chapter.icon === null ? chapter.type : chapter.icon;
                if(chapter.state === 'current'){
                    iconName += '_current';
                }
                else{
                    iconName += '_unlocked';
                }
                return "/images/master-dashboard/" + iconName + ".svg";
            }
        }
    }
</script>

<style scoped lang="scss">
    .icon{
        width: 32px;
        height: 32px;
        min-width: 32px;
    }

    .locked {
        opacity: 0.65;
    }
</style>
